export const findHighlightIndexByTag = (highlights, tag) => {
    if (!tag || !highlights?.length) return -1;

    return highlights.findIndex((highlight) => highlight?.tag?.toLowerCase() === tag.toLowerCase());
};

export const mergeHighlightsFromCarousels = (carouselsFromConfig, visibleCount) => {
    if (!carouselsFromConfig?.length) return [];

    return carouselsFromConfig.slice(0, visibleCount).flatMap((carousel) => carousel.highlights || []);
};
